var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8734 6C19.1028 6 21.3575 8.22538 21.3575 11.4146V20.5854C21.3575 23.7746 19.1028 26 15.8734 26H8.15068C4.92131 26 2.66663 23.7746 2.66663 20.5854V11.4146C2.66663 8.22538 4.92131 6 8.15068 6H15.8734ZM26.6106 9.17198C27.1959 8.87418 27.8826 8.90531 28.4413 9.25726C29 9.60785 29.3333 10.217 29.3333 10.883V21.1178C29.3333 21.7852 29 22.393 28.4413 22.7436C28.1359 22.9344 27.7946 23.0319 27.4506 23.0319C27.1639 23.0319 26.8773 22.9642 26.6093 22.8275L24.6346 21.8312C23.9039 21.4603 23.4506 20.7158 23.4506 19.8887V12.1107C23.4506 11.2823 23.9039 10.5378 24.6346 10.1696L26.6106 9.17198Z",
    fill: "#D20E50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPink);
export default __webpack_public_path__ + "static/media/VideoPink.8fa7ec4f.svg";
export { ForwardRef as ReactComponent };